import React from 'react';
import PropType from 'prop-types';
import ExternalLink from '../Link/ExternalLink';

const PLATFORMS = { ITUNES: 'ITUNES', PLAY: 'PLAY' };

export default function AppStoreButton({ platform, className }) {
  return (
    <ExternalLink
      href={platform === PLATFORMS.PLAY ? __BRAND__.appStores.play : __BRAND__.appStores.iTunes }
      className={className}
    >
      <img
        src={`/images/appstore/${platform === PLATFORMS.PLAY ? 'googleplaybadge' : 'appstorebadge'}.svg`}
        alt={`Download on ${platform === PLATFORMS.PLAY ? 'Google play' : 'Itunes'}`}
        className="appstore-badge"
      />
    </ExternalLink>
  );
}
AppStoreButton.defaultProps = {
  className: null,
};
AppStoreButton.propTypes = {
  platform: PropType.string.isRequired,
  className: PropType.string,
};
